import _slicedToArray from "/builds/digigear/racehorse-nft-website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/builds/digigear/racehorse-nft-website/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/builds/digigear/racehorse-nft-website/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _taggedTemplateLiteral from "/builds/digigear/racehorse-nft-website/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _excluded = ["children"],
    _excluded2 = ["height", "containerDecors", "narrow", "children", "className"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15;

import "core-js/modules/esnext.global-this.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import React__default, { createContext, useContext, useState, useEffect, cloneElement } from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
var TrackingContext = createContext({
  trackEvent: function trackEvent() {}
});

function useTracking() {
  return useContext(TrackingContext);
}

var ElementsConfig = React__default.createContext({
  Link: "a"
});

function useElementsConfig() {
  return React__default.useContext(ElementsConfig);
}

var UnstyledButton = styled.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  // https://stackoverflow.com/a/45890842\n\n  background: none;\n  color: inherit;\n  border: none;\n  padding: 0;\n  font: inherit;\n  cursor: ", ";\n  outline: inherit;\n\n  display: inline-flex;\n\n  svg {\n    display: block;\n  }\n"])), function (props) {
  return props.disabled ? "unset" : "pointer";
});
var BaseButton = React__default.forwardRef(function (props, ref) {
  var _useTracking = useTracking(),
      trackEvent = _useTracking.trackEvent;

  var _useElementsConfig = useElementsConfig(),
      Link = _useElementsConfig.Link;

  var handleClick = function handleClick(e) {
    if (props.disabled) {
      e.preventDefault();
    } else {
      if (props.track) {
        trackEvent(props.track);
      }

      if (props.onClick) {
        props.onClick(e);
      }
    }
  };

  var asComp = "button";

  if (props.to) {
    asComp = Link;
  } else if (props.href) {
    asComp = "a";
  }

  return /* @__PURE__ */React__default.createElement(UnstyledButton, _objectSpread(_objectSpread({
    onClick: handleClick
  }, props), {}, {
    as: asComp,
    ref: ref
  }));
});

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */


function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
/**
 * Adds a CSS class to a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */


function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!hasClass(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}

function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
/**
 * Removes a CSS class from a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */


function removeClass$1(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}

var config = {
  disabled: false
};
var TransitionGroupContext = React__default.createContext(null);
var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [ReactDOM.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : ReactDOM.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children;
    _this$props.in;
    _this$props.mountOnEnter;
    _this$props.unmountOnExit;
    _this$props.appear;
    _this$props.enter;
    _this$props.exit;
    _this$props.timeout;
    _this$props.addEndListener;
    _this$props.onEnter;
    _this$props.onEntering;
    _this$props.onEntered;
    _this$props.onExit;
    _this$props.onExiting;
    _this$props.onExited;
    _this$props.nodeRef;

    var childProps = _objectWithoutPropertiesLoose(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      React__default.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : React__default.cloneElement(React__default.Children.only(children), childProps))
    );
  };

  return Transition;
}(React__default.Component);

Transition.contextType = TransitionGroupContext;
Transition.propTypes = {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
var Transition$1 = Transition;

var _addClass = function addClass$1(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return addClass(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return removeClass$1(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */


var CSSTransition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    };

    _this.onEnter = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument[0],
          appearing = _this$resolveArgument[1];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');

      if (_this.props.onEnter) {
        _this.props.onEnter(maybeNode, maybeAppearing);
      }
    };

    _this.onEntering = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument2[0],
          appearing = _this$resolveArgument2[1];

      var type = appearing ? 'appear' : 'enter';

      _this.addClass(node, type, 'active');

      if (_this.props.onEntering) {
        _this.props.onEntering(maybeNode, maybeAppearing);
      }
    };

    _this.onEntered = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument3[0],
          appearing = _this$resolveArgument3[1];

      var type = appearing ? 'appear' : 'enter';

      _this.removeClasses(node, type);

      _this.addClass(node, type, 'done');

      if (_this.props.onEntered) {
        _this.props.onEntered(maybeNode, maybeAppearing);
      }
    };

    _this.onExit = function (maybeNode) {
      var _this$resolveArgument4 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument4[0];

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      _this.addClass(node, 'exit', 'base');

      if (_this.props.onExit) {
        _this.props.onExit(maybeNode);
      }
    };

    _this.onExiting = function (maybeNode) {
      var _this$resolveArgument5 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument5[0];

      _this.addClass(node, 'exit', 'active');

      if (_this.props.onExiting) {
        _this.props.onExiting(maybeNode);
      }
    };

    _this.onExited = function (maybeNode) {
      var _this$resolveArgument6 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument6[0];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, 'exit', 'done');

      if (_this.props.onExited) {
        _this.props.onExited(maybeNode);
      }
    };

    _this.resolveArguments = function (maybeNode, maybeAppearing) {
      return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] // here `maybeNode` is actually `appearing`
      : [maybeNode, maybeAppearing];
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
      return {
        baseClassName: baseClassName,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.addClass = function addClass(node, type, phase) {
    var className = this.getClassNames(type)[phase + "ClassName"];

    var _this$getClassNames = this.getClassNames('enter'),
        doneClassName = _this$getClassNames.doneClassName;

    if (type === 'appear' && phase === 'done' && doneClassName) {
      className += " " + doneClassName;
    } // This is to force a repaint,
    // which is necessary in order to transition styles when adding a class name.


    if (phase === 'active') {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
    }

    if (className) {
      this.appliedClasses[type][phase] = className;

      _addClass(node, className);
    }
  };

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$appliedClasses$ = this.appliedClasses[type],
        baseClassName = _this$appliedClasses$.base,
        activeClassName = _this$appliedClasses$.active,
        doneClassName = _this$appliedClasses$.done;
    this.appliedClasses[type] = {};

    if (baseClassName) {
      removeClass(node, baseClassName);
    }

    if (activeClassName) {
      removeClass(node, activeClassName);
    }

    if (doneClassName) {
      removeClass(node, doneClassName);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props;
    _this$props.classNames;

    var props = _objectWithoutPropertiesLoose(_this$props, ["classNames"]);

    return /*#__PURE__*/React__default.createElement(Transition$1, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(React__default.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes = {};
var CSSTransition$1 = CSSTransition;

var NoopTransition = function NoopTransition(_ref4) {
  var children = _ref4.children,
      props = _objectWithoutProperties(_ref4, _excluded);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      transitionIn = _useState2[0],
      setTransitionIn = _useState2[1];

  useEffect(function () {
    setTransitionIn(true);
  }, []);
  return /* @__PURE__ */React.createElement(React.Fragment, null, React.Children.map(children, function (c) {
    return typeof window !== "undefined" ? /* @__PURE__ */React.createElement(CSSTransition$1, {
      in: transitionIn,
      timeout: 200
    }, cloneElement(c, props)) : cloneElement(c, _objectSpread(_objectSpread({}, props), {}, {
      className: [props.className || "", "enter-done"].join(" ")
    }));
  }));
};

var FadeInTransition = styled(NoopTransition)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  opacity: 0;\n\n  &.enter-active {\n    opacity: 1;\n    transition: opacity 0.2s;\n  }\n\n  &.enter-done {\n    opacity: 1;\n  }\n"])));
var AutoLayout = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: ", ";\n\n  ", ";\n\n  ", "\n"])), function (props) {
  return props.direction;
}, function (props) {
  return {
    justifyContent: props.justifyContent,
    alignItems: props.alignItems,
    gap: props.gap,
    flex: props.flex,
    flexGrow: props.flexGrow,
    flexShrink: props.flexShrink,
    flexWrap: props.flexWrap
  };
}, function (props) {
  return props.noItemMargin && css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      & > * {\n        margin: 0;\n      }\n    "])));
});
AutoLayout.propTypes = {
  direction: PropTypes.oneOf(["row", "column", "row-reverse", "column-reverse"]).isRequired,
  justifyContent: PropTypes.oneOf(["flex-start", "flex-end", "center", "space-between", "space-around", "space-evenly"]),
  alignItems: PropTypes.oneOf(["stretch", "flex-start", "flex-end", "center", "stretch", "baseline"]),
  gap: PropTypes.number,
  flex: PropTypes.any,
  flexGrow: PropTypes.number,
  flexShrink: PropTypes.number,
  noItemMargin: PropTypes.bool
};
var ResponsiveLayout = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: ", ";\n  justify-content: center;\n  align-items: center;\n\n  gap: ", "px;\n\n  @media screen and (max-width: ", ") {\n    flex-direction: column;\n\n    ", ";\n  }\n"])), function (props) {
  return props.reversed ? "row-reverse" : "row";
}, function (props) {
  return typeof props.gap === "number" ? props.gap : 0;
}, function (props) {
  return props.breakpoint ? props.breakpoint + "px" : props.theme.dimensions.breakpoint;
}, function (props) {
  return props.vertical;
});
ResponsiveLayout.propTypes = {
  gap: PropTypes.number,
  reversed: PropTypes.bool,
  breakpoint: PropTypes.number,
  vertical: PropTypes.any
};
var Anchor = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  position: relative;\n  top: -", ";\n"])), function (props) {
  return props.theme.dimensions.headerHeight;
});

var OffsetAnchor = function OffsetAnchor(_ref5) {
  var id = _ref5.id;
  return /* @__PURE__ */React__default.createElement("div", null, /* @__PURE__ */React__default.createElement(Anchor, {
    id: id
  }));
};

OffsetAnchor.propTypes = {
  id: PropTypes.string.isRequired
};
var DefaultContext = {
  color: undefined,
  size: undefined,
  className: undefined,
  style: undefined,
  attr: undefined
};
var IconContext = React__default.createContext && React__default.createContext(DefaultContext);

var __assign = globalThis && globalThis.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = globalThis && globalThis.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

function Tree2Element(tree) {
  return tree && tree.map(function (node, i) {
    return React__default.createElement(node.tag, __assign({
      key: i
    }, node.attr), Tree2Element(node.child));
  });
}

function GenIcon(data) {
  return function (props) {
    return React__default.createElement(IconBase, __assign({
      attr: __assign({}, data.attr)
    }, props), Tree2Element(data.child));
  };
}

function IconBase(props) {
  var elem = function elem(conf) {
    var attr = props.attr,
        size = props.size,
        title = props.title,
        svgProps = __rest(props, ["attr", "size", "title"]);

    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props.className) className = (className ? className + ' ' : '') + props.className;
    return React__default.createElement("svg", __assign({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className: className,
      style: __assign(__assign({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && React__default.createElement("title", null, title), props.children);
  };

  return IconContext !== undefined ? React__default.createElement(IconContext.Consumer, null, function (conf) {
    return elem(conf);
  }) : elem(DefaultContext);
} // THIS FILE IS AUTO GENERATED


function MdMenu(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "fill": "none",
        "d": "M0 0h24v24H0z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
      }
    }]
  })(props);
}

var Bar = styled.header(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  width: 100vw;\n\n  position: relative;\n  z-index: 1000;\n\n  ", "\n\n  padding-left: 32px;\n  padding-right: 32px;\n  box-sizing: border-box;\n\n  @media screen and (max-width: ", ") {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n\n  .spacer {\n    flex: 1;\n  }\n\n  @media screen and (min-width: ", "px) {\n    .narrow-only {\n      display: none;\n    }\n  }\n\n  @media screen and (max-width: ", ") {\n    .wide-only {\n      display: none;\n    }\n  }\n"])), function (props) {
  return props.fixed && css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n      position: fixed;\n      top: 0;\n      left: 0;\n    "])));
}, function (props) {
  return props.theme.dimensions.breakpoint;
}, function (props) {
  return parseInt(props.theme.dimensions.breakpoint, 10) + 1;
}, function (props) {
  return props.theme.dimensions.breakpoint;
});
var Content$1 = styled(AutoLayout)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  margin-left: auto;\n  margin-right: auto;\n\n  max-width: ", ";\n  height: ", ";\n\n  font-size: 19px;\n\n  box-sizing: border-box;\n"])), function (props) {
  return props.theme.dimensions.pageWidth;
}, function (props) {
  return props.theme.dimensions.headerHeight;
});
var StyledHamburgerButton = styled(BaseButton)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  width: 24px;\n  height: 24px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  transition: transform 0.4s;\n\n  &.open {\n    transform: rotate(180deg);\n  }\n"])));

var HamburgerButton = function HamburgerButton(_ref6) {
  var className = _ref6.className,
      open = _ref6.open,
      onClick = _ref6.onClick,
      children = _ref6.children;
  return /* @__PURE__ */React__default.createElement(StyledHamburgerButton, {
    className: "".concat(open ? "open" : "", " ").concat(className),
    onClick: onClick,
    "aria-label": "Menu"
  }, /* @__PURE__ */React__default.createElement(MdMenu, null));
};

var HamburgerMenu = styled(AutoLayout).attrs({
  direction: "column"
})(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  position: relative;\n  z-index: 1000;\n"])));
var Outside = styled.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 999;\n"])));
var Placeholder = styled.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  height: ", ";\n"])), function (props) {
  return props.theme.dimensions.headerHeight;
});

var BaseHeader = function BaseHeader(_ref7) {
  var cta = _ref7.cta,
      children = _ref7.children,
      logo = _ref7.logo,
      fixed = _ref7.fixed,
      justifyChildren = _ref7.justifyChildren,
      gap = _ref7.gap,
      className = _ref7.className,
      style = _ref7.style,
      placeholderProps = _ref7.placeholderProps;

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      atTop = _useState4[0],
      setAtTop = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      menuOpen = _useState6[0],
      setMenuOpen = _useState6[1];

  useEffect(function () {
    setAtTop(window.scrollY <= 10);

    var handleScroll = function handleScroll() {
      setAtTop(window.scrollY <= 10);
    };

    window.addEventListener("scroll", handleScroll);
    return function () {
      return window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return /* @__PURE__ */React__default.createElement(React__default.Fragment, null, /* @__PURE__ */React__default.createElement(Bar, {
    fixed: fixed,
    className: "".concat(atTop ? "at-top" : "", " ").concat(menuOpen ? "menu-open" : "", " ").concat(className),
    style: style
  }, /* @__PURE__ */React__default.createElement(Content$1, {
    className: "content",
    direction: "row",
    alignItems: "center",
    gap: gap
  }, logo, /* @__PURE__ */React__default.createElement(AutoLayout, {
    direction: "row",
    className: "wide-only",
    justifyContent: justifyChildren || "flex-start",
    flex: 1,
    style: {
      alignSelf: "stretch"
    }
  }, children), /* @__PURE__ */React__default.createElement("div", {
    className: "spacer narrow-only"
  }), /* @__PURE__ */React__default.createElement(AutoLayout, {
    direction: "row"
  }, cta), /* @__PURE__ */React__default.createElement(HamburgerButton, {
    className: "narrow-only",
    onClick: function onClick() {
      return setMenuOpen(!menuOpen);
    }
  }, /* @__PURE__ */React__default.createElement(MdMenu, null))), menuOpen && /* @__PURE__ */React__default.createElement(HamburgerMenu, {
    className: "narrow-only"
  }, children)), menuOpen && /* @__PURE__ */React__default.createElement(Outside, {
    className: "narrow-only",
    onClick: function onClick() {
      return setMenuOpen(false);
    }
  }), fixed && /* @__PURE__ */React__default.createElement(Placeholder, _objectSpread({}, placeholderProps)));
};

BaseHeader.propTypes = {
  cta: PropTypes.node,
  children: PropTypes.node,
  logo: PropTypes.node.isRequired,
  fixed: PropTypes.bool,
  justifyChildren: PropTypes.oneOf(["flex-start", "flex-end", "center", "space-between", "space-around", "space-evenly"]),
  gap: PropTypes.any,
  placeholderProps: PropTypes.any
};
var StyledSection = styled.section(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  width: 100%;\n\n  box-sizing: border-box;\n  padding: 80px 32px 80px 32px;\n  height: ", ";\n\n  @media screen and (max-width: ", ") {\n    padding: 40px 16px 40px 16px;\n  }\n\n  position: relative;\n\n  overflow: hidden;\n"])), function (props) {
  return props.height === "full" ? "calc(100vh - ".concat(props.theme.dimensions.headerHeight, ")") : "auto";
}, function (props) {
  return props.theme.dimensions.breakpoint;
});
var Content = styled.div(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  max-width: 1280px;\n\n  margin-left: auto;\n  margin-right: auto;\n\n  height: 100%;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n\n  &.narrow {\n    max-width: 1040px;\n  }\n"])));

var ContentSection = function ContentSection(_ref8) {
  var height = _ref8.height,
      containerDecors = _ref8.containerDecors,
      _ref8$narrow = _ref8.narrow,
      narrow = _ref8$narrow === void 0 ? false : _ref8$narrow,
      children = _ref8.children,
      className = _ref8.className,
      props = _objectWithoutProperties(_ref8, _excluded2);

  return /* @__PURE__ */React.createElement(StyledSection, _objectSpread({
    className: className || "",
    height: height
  }, props), containerDecors, /* @__PURE__ */React.createElement(Content, {
    className: "content " + (narrow ? "narrow" : "wide")
  }, children));
};

export { AutoLayout, BaseButton, BaseHeader, ContentSection, ElementsConfig, FadeInTransition, OffsetAnchor, ResponsiveLayout, TrackingContext, useElementsConfig, useTracking };